import { render, staticRenderFns } from "./CallIcon.vue?vue&type=template&id=4515ad20&"
import script from "./CallIcon.vue?vue&type=script&lang=js&"
export * from "./CallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports